import { useState } from "react";
import "./Footer.scss";
import { BsInstagram, BsTelegram, BsWhatsapp } from "react-icons/bs";
import logo from "../../assets/images/logo/ChatGPT Image Nov 17, 2025, 04_11_35 PM.png";
import { NavLink } from "react-router-dom";
import { socialLinks } from "../../constants/navigation.js";

const hospitalLinks = [
  { id: 1, label: "خدمات بیمارستان", path: "/appointment-booking" },
  { id: 2, label: "محصولات ویژه سگ‌ها", path: "/category/1" },
  { id: 3, label: "محصولات ویژه گربه‌ها", path: "/category/2" },
  { id: 4, label: "محصولات ویژه پرندگان", path: "/category/4" },
];

const supportLinks = [
  { id: 1, label: "خانه", path: "/" },
  { id: 2, label: "فروشگاه", path: "/store" },
  { id: 3, label: "وبلاگ", path: "/blog" },
  { id: 4, label: "درباره ما", path: "/aboutus" },
];

const contactInfo = {
  address: "تهران، بلوار دامپزشک، پلاک ۲۴ – بیمارستان دامپزشکی پت مدیک",
  phone: "۰۲۱-۱۲۳۴۵۶۷۸",
  mobile: "۰۹۱۲۱۲۳۴۵۶۷",
  whatsapp: "https://wa.me/989121234567",
  email: "info@petmedic.ir",
};

const iconMap = {
  instagram: <BsInstagram />,
  whatsapp: <BsWhatsapp />,
  telegram: <BsTelegram />,
};

export default function Footer() {
  const [newsletter, setNewsletter] = useState({ name: "", contact: "" });

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
    setNewsletter({ name: "", contact: "" });
  };

  return (
    <footer className="site-footer" id="footer-container">
      <div className="footer-top">
        <div className="footer-brand">
          <img src={logo} alt="پت مدیک" />
          <p>
            پت مدیک ترکیبی از پت‌شاپ آنلاین و بیمارستان دامپزشکی شبانه‌روزی است. تیم
            ما با بهره‌گیری از دامپزشکان متخصص، بهترین تجهیزات تشخیصی و تنوع کم‌نظیر
            محصولات مراقبتی، از سلامت و شادی حیوان خانگی شما پشتیبانی می‌کند.
          </p>
          <div className="footer-social">
            {socialLinks.map((link) => (
              <a key={link.id} href={link.href} target="_blank" rel="noreferrer">
                {iconMap[link.icon]}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-columns">
          <div className="footer-col">
            <h4>اطلاعات تماس</h4>
            <p>{contactInfo.address}</p>
            <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
            <a href={`tel:${contactInfo.mobile}`}>{contactInfo.mobile}</a>
            <a href={contactInfo.whatsapp} target="_blank" rel="noreferrer">
              پشتیبانی واتساپ
            </a>
            <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
          </div>

          <div className="footer-col">
            <h4>لینک‌های مفید</h4>
            {hospitalLinks.map((link) => (
              <NavLink key={link.id} to={link.path}>
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="footer-col">
            <h4>دسترسی سریع</h4>
            {supportLinks.map((link) => (
              <NavLink key={link.id} to={link.path}>
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="footer-col newsletter">
            <h4>عضویت در خبرنامه</h4>
            <p>برای دریافت تخفیف‌ها و نکات مراقبتی شماره یا ایمیل خود را وارد کنید.</p>
            <form onSubmit={handleNewsletterSubmit}>
              <input
                type="text"
                placeholder="نام و نام خانوادگی"
                value={newsletter.name}
                onChange={(e) => setNewsletter({ ...newsletter, name: e.target.value })}
              />
              <input
                type="text"
                placeholder="شماره موبایل یا ایمیل"
                value={newsletter.contact}
                onChange={(e) =>
                  setNewsletter({ ...newsletter, contact: e.target.value })
                }
              />
              <button type="submit">عضویت در خبرنامه</button>
            </form>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} پت مدیک - تمام حقوق محفوظ است.</span>
        <button
          className="scroll-top"
          onClick={() =>
            document
              .getElementById("header-container")
              ?.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          بازگشت به بالا
        </button>
        <a
          href="https://example.com"
          target="_blank"
          rel="noreferrer"
          className="designer"
        >
          طراحی و توسعه وب‌سایت
        </a>
      </div>
    </footer>
  );
}
